export const examples = [
  'hh:mm:ss a dd/LL/yyyy O',
  'HH:mm:ss dd/LL/yyyy',
  'HH:mm:ss.SSS',
  'dd-LL-yyyy'
];
